<div class="login-container">
  <div class="logo-container">
    <img src="assets/img/logo-projecao-profissional.svg" alt="Logo Projeção Profissional" class="login-logo" />
  </div>
  <h1 class="login-title">Acesso ao Sistema</h1>
  <p class="login-subtitle">Entre com suas credenciais para acessar a plataforma</p>

  <form *ngIf="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()" (keydown.enter)="onSubmit()">
    <mat-form-field appearance="outline" class="username-field">
      <mat-label>Usuário</mat-label>
      <input
        matInput
        data-cy="username-input"
        type="text"
        formControlName="username"
        name="username"
        required
        autocomplete="username"
      />
      <mat-error *ngIf="loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched">
        Usuário é obrigatório
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="password-field">
      <mat-label>Senha</mat-label>
      <input
        matInput
        data-cy="password-input"
        [type]="hidePassword ? 'password' : 'text'"
        formControlName="password"
        name="password"
        required
        autocomplete="current-password"
      />
      <button
        mat-icon-button
        matSuffix
        type="button"
        (click)="togglePasswordVisibility()"
        [attr.aria-label]="hidePassword ? 'Mostrar senha' : 'Esconder senha'"
        class="password-toggle-button"
      >
        <mat-icon>{{ hidePassword ? "visibility" : "visibility_off" }}</mat-icon>
      </button>
      <mat-error *ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched">
        Senha é obrigatória
      </mat-error>
    </mat-form-field>

    <mat-checkbox formControlName="rememberMe" data-cy="rememberMe" class="remember-me-checkbox">
      Manter conectado
    </mat-checkbox>

    <!-- Botão Entrar - oculto quando está carregando -->
    <button
      *ngIf="!isLoading"
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="loginForm.invalid"
      data-cy="submit"
      class="login-submit-button"
    >
      Entrar
    </button>

    <!-- Loading centralizado - aparece quando está carregando -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40" class="centered-spinner"></mat-spinner>
    </div>
  </form>

  <a routerLink="/esqueceu-a-senha" data-cy="forgot-password" class="forgot-password d-block text-center mt-3">
    Esqueceu a senha?
  </a>
</div>
